<h2>{{ 'aumico_admin_ar_template_settings_title' | i18next }}</h2>

<div class="flex-container">
    <span class="flex-item">
        <aum-toggle
            [aumFormControl]="formGroup.controls['uncoveredShortfall']"
            [caption]="'aumico_admin_ar_template_settings_uncovered_shortfall' | i18next"
        >
        </aum-toggle>
    </span>
    <span class="flex-item">
        <aum-toggle
            [aumFormControl]="formGroup.controls['showShareholderInfo']"
            [caption]="'aumico_admin_ar_template_settings_show_shareholder_information' | i18next"
        >
        </aum-toggle>
    </span>
</div>
